import UnSupportFilePreview from './UnSupportFilePreview';
import './style/index.less';

export default UnSupportFilePreview;
